import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-cashbook-beallitas',
  templateUrl: './cashbook-beallitas.component.html',
  styleUrls: ['./cashbook-beallitas.component.scss'],
})
export class CashbookBeallitasComponent implements OnInit {
  loading = false;
  saving = false;
  settings: { url: string; enabled: boolean; api_key: string } = { url: '', enabled: true, api_key: '' };
  hasApiKey = false;
  apiKeyMask = '';

  constructor(private http: HttpClient, private data: DataService) { }

  ngOnInit() {
    this.loadSettings();
  }

  loadSettings() {
    this.loading = true;
    this.http.get<any>('/api/admin/cashbook-beallitas').subscribe({
      next: (r) => {
        this.settings = { url: r?.url || '', enabled: !!r?.enabled, api_key: '' };
        this.hasApiKey = !!r?.has_api_key;
        this.apiKeyMask = r?.api_key_mask || '';
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.data.sendToast('Nem sikerült betölteni a Cashbook beállításokat.', 'error');
      },
    });
  }

  saveSettings() {
    this.saving = true;
    this.http.put<any>('/api/admin/cashbook-beallitas', this.settings).subscribe({
      next: (r) => {
        this.settings = { url: r?.url || '', enabled: !!r?.enabled, api_key: '' };
        this.hasApiKey = !!r?.has_api_key;
        this.apiKeyMask = r?.api_key_mask || '';
        this.saving = false;
        this.data.sendToast('Cashbook beállítások mentve.', 'success');
      },
      error: () => {
        this.saving = false;
        this.data.sendToast('Nem sikerült menteni a Cashbook beállításokat.', 'error');
      },
    });
  }
}
